import React from 'react';
import { Table } from 'antd';
import CustomSelector from '@shared/components/CustomSelector';

const BLANK_OPTION = {
  title: 'N/A',
  value: ''
};

/**
 * @typedef {object} ObservationTableAssignedObservees
 * @property {number} externalUserId
 * @property {string} currentRoleName
 * @property {string} name
 * @property {string|number} [observerExternalUserId]
 */

/**
 * @typedef {object} ObservationTableAtmObservers
 * @property {string} title
 * @property {number} value
 */

/**
 * @typedef {object} ObservationTableProps
 * @property {boolean} [loading]
 * @property {ObservationTableAssignedObservees[]} [assignedObservees]
 * @property {Array<number>} [assignedObserverIds]
 * @property {ObservationTableAtmObservers[]} [atmObservers]
 * @property {(externalUserId: number, newValue: number | string) => void} setATMValue
 */

/**
 * @param {ObservationTableProps} props
 */
const ObservationTable = props => {
  const { assignedObservees, assignedObserverIds, atmObservers, setATMValue } = props;

  const selectorOptions = [BLANK_OPTION, ...atmObservers];

  const columns = [
    {
      title: 'Role',
      dataIndex: 'currentRoleName',
      width: '20%',
      sorter: (a, b) => a.currentRoleName.localeCompare(b.currentRoleName)
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '40%',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: 'Assignment',
      dataIndex: 'observerExternalUserId',
      width: '40%',
      render: (value, record) => {
        const filteredOptions = selectorOptions.filter(
          option => option.value === value || !assignedObserverIds.some(id => id === option.value)
        );

        return (
          <CustomSelector
            id='atm-observer-selector'
            testId='atm-observer-selector'
            options={filteredOptions}
            value={value || ''}
            setValue={newValue => {
              setATMValue(record.externalUserId, newValue);
            }}
          />
        );
      }
    }
  ];

  return (
    <Table
      data-testid='observation-table'
      rowKey='externalUserId'
      className='observation-table'
      columns={columns}
      dataSource={assignedObservees}
      pagination={false}
      showSorterTooltip={false}
    />
  );
};

export default ObservationTable;
